import ManagementSidebar from "components/common/ManagementSidebar";
import img from "assets/images/effective-business-team-office-group-work-vector-34356039.jpg";
import ManagementContent from "components/common/ManagementContent";
import { useState, useContext, useEffect } from "react";
import WithAuthentication from "Authentication/AuthenticationContext.ts";

export default function SuperAdminHome() {
  const [requestId, setRequestId] = useState([0]);
  const auth = useContext(WithAuthentication);
  const [accessLevel, setAccessLevel] = useState({});
  useEffect(() => {
    let temp = [];
    for (let i = 0; i < auth.userInfo.access_level.length; i++) {
      temp.push(auth.userInfo.access_level[i].code);
    }
    console.log("testtt", temp, auth.userInfo);
    setAccessLevel(temp);
  }, []);
  const requestIdHandler = (id) => {
    let temp = [...requestId];
    // console.log({
    //   temp,
    //   requestId,
    //   test: !requestId.includes(id),
    // });
    !requestId.includes(id) && (temp = [...temp, id]);
    setRequestId(temp);
  };
  // console.log("requestID", requestId);

  return (
    <div className=" d-flex">
      <ManagementSidebar
        accessLevel={accessLevel}
        requestIdHandler={requestIdHandler}
      />
      <ManagementContent accessLevel={accessLevel} requestId={requestId} />
      {/* <div className="container text-center">
        <img src={img} style={{ width: "50%" }} />
        <h5> به مدیریت سبدی خوش آمدید</h5>
      </div> */}
    </div>
  );
}
